export enum LayoutType {
  WipGridColumn = 1,
  WipGridFilter = 2,
  GlobalReport = 3,
}